import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomTextInput from "../../../common/general/CustomTextInput/CustomTextInput";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import CustomSpacing from "../../../common/layout/CustomSpacing/CustomSpacing";

const ObjectiveForm = ({
  objective = "",
  criteria = "",
  onObjectiveChange,
  onCriteriaChange,
  onSave,
  onCancel,
  disabled = false,
  isEditMode = false,
  saveButtonText = "Add Objective with Criteria",
}) => {
  const handleSave = () => {
    if (objective.trim()) {
      onSave({
        objective: objective.trim(),
        criteria: criteria.trim(),
      });
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <CustomText
          text={isEditMode ? "Learning Objective" : "Learning Objective Name"}
          size="s"
          weight="bold"
          useTranslationText={false}
        />
        <CustomButton
          text="Cancel"
          onPress={onCancel}
          styleType="transparent"
          size="xs"
          textStyle={{ color: "#667085" }}
        />
      </View>

      <CustomTextInput
        placeholder="Enter Objective Name"
        value={objective}
        onChangeText={onObjectiveChange}
        editable={!disabled}
        style={{}}
      />

      <CustomSpacing type="vertical" size="m" />

      <CustomText text="Evaluation Criteria" size="s" weight="bold" useTranslationText={false} />

      <CustomSpacing type="vertical" size="s" />

      <CustomTextInput
        placeholder="Enter evaluation criteria for this objective"
        value={criteria}
        onChangeText={onCriteriaChange}
        editable={!disabled}
        multiline
        style={styles.criteriaInput}
      />

      <CustomSpacing type="vertical" size="m" />

      <CustomButton
        text={saveButtonText}
        onPress={handleSave}
        disabled={disabled || !objective.trim()}
        styleType={objective.trim() ? "primary" : "disabled"}
        size="s"
        style={{ maxWidth: "fit-content" }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#F9FAFB",
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  criteriaInput: {
    backgroundColor: "#F9FAFB",
    borderRadius: 6,
    marginBottom: 8,
    minHeight: 80,
    textAlignVertical: "top",
  },
});

export default ObjectiveForm;
